import './flow-item.css';

import { IonIcon, IonLabel } from '@ionic/react';
import { flag } from 'ionicons/icons';
import { ReactElement } from 'react';
import { getLocalizedText } from '../../../../../../i18n/i18n.utils';

const EndItemComponent = (): ReactElement => {
  const classList: string[] = ['machine-flow-item'];

  return (
    <div className="flow-item-container">
      <div className={classList.join(' ')}>
        <div className="machine-flow-item-icon">
          <div className="center bg-tint full-hw">
            <IonIcon icon={flag} className="text-color-medium" />
          </div>
        </div>
        <div className="machine-flow-item-title">
          <IonLabel>{getLocalizedText('common:end')}</IonLabel>
        </div>
      </div>
    </div>
  );
};

export { EndItemComponent };
